module.exports = __webpack_public_path__ + "img/12.20fabc66.webp";